module.exports = __webpack_public_path__ + "fonts/295ff20c-2b48-4fa6-be92-a53bbf9bbbb4.7f68cd6c.ttf";